import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { withTranslation } from "react-i18next";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { Row, Col, Container, Button } from "react-bootstrap";
import WithError from "../common/WithError";
import http from "../../api/http-request";
import GoogleCaptcha from "../common/GoogleCaptcha";
import ErrorCard from "../common/ErrorCard";
import { getRoutePath,getLoginUrl,getNestedObject,pageNotFound,randomCount } from "../../utils/common";
import Carousel1 from "../../assets/images/MFA-Background-001.png";
import Carousel2 from "../../assets/images/MFA-Background-002.png";
import Carousel3 from "../../assets/images/MFA-Background-003.png";
import Carousel4 from "../../assets/images/MFA-Background-004.png";
import Carousel5 from "../../assets/images/MFA-Background-005.png";
import Carousel6 from "../../assets/images/MFA-Background-006.png";
import Carousel7 from "../../assets/images/MFA-Background-007.png";
import Carousel9 from "../../assets/images/reg9.jpg";
import Radio from "../common/Radio";
import ReactCodeInput from 'react-verification-code-input';
import downChevron from '../../assets/images/down-chevron.svg';

class ForgotUserName extends Component {
  constructor(props) {
    super(props);
    this.verificationInputRef = React.createRef();
    this.state = {
      emailError: false,
      mail: "",
      errorText: "",
      showGoogleCaptcha: false,
      googleCaptchaToken: "",
      token: "",
      googleCaptchaResponse: "",
      captchaReset: false,
      showSuccessMsg: "",
      showErrorMsg: false,
      carouselImages: [{'image':Carousel3},{'image':Carousel4},{'image':Carousel1},{'image':Carousel2},{'image':Carousel6},{'image':Carousel5},{'image':Carousel7},{'image':Carousel9}],
      imageIndex:null,
      screen:1,
      userEmail:"",
      userPhone:"",
      selectedOption:"",
      verificationCode: "",
      verificationOption:"",
      changeMethod:"",
      verificationPlaceholder:['0','0','0','0','0','0','0','0'],
      authenticateData: {},
      switchMethod: false,
      seeMore:false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.displayRandomImage();
    this.getAuthID();
  }

  genericResponse = (res) => {
    if(getNestedObject(res, ["data", "callbacks"])) {
      const {
        data: {
          callbacks
        }
      } = res;
      if(callbacks) {
        if (callbacks[0].type === 'ReCaptchaCallback') {
          const token = getNestedObject(res, ["data", "authId"]);
          if (token) {
            this.setState({
              token
            });
          }
          const recaptchaSiteKey = res.data.callbacks[0].output[0].value;
          if (recaptchaSiteKey) {
            this.setState({
              showGoogleCaptcha: true,
              googleCaptchaToken: recaptchaSiteKey,
              authenticateData: res.data,
              switchMethod: false
            });
          } else {
            this.setState({
              showSuccessMsg: true
            });
          }
        } else if (callbacks[1].type === 'ChoiceCallback') {
          // this.setState({
          //   showSuccessMsg: true
          // });
          const token = getNestedObject(res, ["data", "authId"]);
          if (token) {
            this.setState({
              token
            });
          }
          this.setState({
            authenticateData: res.data,
            screen:2,
            userEmail:res.data.callbacks[1].output[1].value[0],
            userPhone:res.data.callbacks[1].output[1].value[1],
            switchMethod: false
          });
        } else if (callbacks[0].output[0].value === 'OTP_COLLECTOR_MFA' || callbacks[0].output[0].value === 'OTP_COLLECTOR_MFA_CHOICE') {
          const token = getNestedObject(res, ["data", "authId"]);
          if (token) {
            this.setState({
              token
            });
          }
          this.setState({
            authenticateData: res.data,
            screen:3,
            switchMethod: false,
            verificationOption:res.data.callbacks[1].output[0].value
          });
          if (callbacks[0].output[0].value === 'OTP_COLLECTOR_MFA_CHOICE') {
            this.setState({
              switchMethod: true,
              changeMethod: res.data.callbacks[1].output[0].value.includes("@") ? "PHONE" : "EMAIL",
            });
          }
          if (callbacks[4].output[0].value === "OTP_VALIDATION_FAILED") {
            this.setState({
                verificationCodeError: "pages.editEmailAddressPopup.invalidOTP"
            });
          }
        } else if (callbacks[0].output[0].value === 'FORGOT_USERNAME_SUCCESS') {
          this.setState({
            showSuccessMsg: true,
            switchMethod: false
          });
        }
      }
    } else if (getNestedObject(res, ["data", "detail", "failureUrl"])) {
      const {
        data: {
          detail: { failureUrl }
        }
      } = res;
      if (failureUrl.includes("https://")) {
        window.location.href = sanitizeUrl(`${res.data.detail.failureUrl}`);
        return;
      }
      let errorMsg = "";
      switch (failureUrl) {
        case "INVALID_CREDENTIALS":
          errorMsg = "common.errors.wrongCredentials";
          break;
        case "ACCOUNT_LOCKED":
          errorMsg = "common.errors.accountLocked";
          break;
        case "ACCOUNT_ALREADY_LOCKED":
          errorMsg = "common.errors.accountAlreadyLocked";
          break;
        case "INTERNAL_ERROR":
          errorMsg = "common.errors.internalError";
          break;
        case "MAX_RETRY_EXCEEDED":
          errorMsg = "common.errors.maxVerifyAttempt";
          break;
        case "MAX_RESEND_EXCEEDED":
          errorMsg = "common.errors.maxResendAttempt";
          break;
        case "USER_NOT_FOUND":
          errorMsg = "pages.forgotUserName.userNotFound";
          break;
        case "INVALID_NUMBER":
          errorMsg = "pages.forgotUserName.invalidNumber";
          break;
        case "ALREADY_LOGGED_IN":
          errorMsg = "pages.forgotUserName.alreadyLoggedIn";
          break;
        default:
          errorMsg = "common.errors.internalError";
          break;
      }
      this.showError(errorMsg);
      this.setState({
        screen:1,
        showGoogleCaptcha:false,
        showSuccessMsg:false,
        showErrorMsg:false,
        mail:'',
        verificationCode:'',
        selectedOption:''
      });
      this.getAuthID();
    } else if (res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
    } else if (res.status === 400 && res.data.message === 'USER_NOT_FOUND'){
        this.showError("pages.forgotUserName.userNotFound");
    } else if(res.status === 500 && res.data.code === 500 && res.data.message === 'TWILIO_ERROR'){
        this.showError("common.errors.twilioError");
        this.setState({
          screen:1,
          showGoogleCaptcha:false,
          showSuccessMsg:false,
          showErrorMsg:false,
          mail:'',
          selectedOption:''
        })
      } else if(res.status === 500 && res.data.code === 500 && res.data.message === 'SMTP_ERROR'){
        this.showError("common.errors.smtpError");
        this.setState({
          screen:1,
          showGoogleCaptcha:false,
          showSuccessMsg:false,
          showErrorMsg:false,
          mail:'',
          selectedOption:''
        })
      } else if(res.status === 401 && res.data.code === 401 && res.data.message === 'Session has timed out'){
        this.showError("common.errors.sessionTimedOut");
        this.setState({
          screen:1,
          showGoogleCaptcha:false,
          showSuccessMsg:false,
          showErrorMsg:false,
          mail:'',
          selectedOption:''
        });
        this.getAuthID();
      } else {
        this.setState({
          showErrorMsg: true
        });
      }
  }

  isEmailValid = (value) => {
    if (
      value.length <= 0 ||
      !value.match(
        /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/
      )
    ) {
      this.setState({
        emailError: true
      });
    } else {
      this.setState({
        emailError: false
      });
    }
  };

  onRecoverUserName = (e) => {
    e.preventDefault();
    const { mail, emailError } = this.state;
    if (mail === "" || emailError) {
      this.setState({
        emailError: true
      });
      this.showError("common.errors.required");
    } else if (mail !== "" && !emailError) {
      this.getForgotUserToken();
      this.setState({
        errorText: ""
      });
    }
  };
  showError = (errorText) => {
    this.setState({
      errorText
    });
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  };

  getForgotUserToken = () => {
    const { mail, authenticateData } = this.state;
    authenticateData.callbacks[0].input[0].value = mail;
    http(
      {
        url: "authenticate?service=ForgotUsername&authIndexType=service&authIndexValue=ForgotUsername",
        data: authenticateData,
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
      
      // else {
      //   this.showError("pages.forgotUserName.unableToRetrieve");
      // }
    });
  };

  onCaptchaChange = (value) => {
    if (value) {
      this.setState(
        {
          googleCaptchaResponse: value
        },
        () => { 
          this.forgotUserNameSubmit();
          
        }
      );
    } else {
      this.setState({
        googleCaptchaResponse: ""
      });
    }
  };

  forgotUserNameSubmit = () => {
    const { googleCaptchaResponse, authenticateData, googleCaptchaToken } = this.state;
    authenticateData.callbacks[0].input[0].value = googleCaptchaResponse;
    authenticateData.callbacks[0].output[0].value = googleCaptchaToken;
    this.setState({
      errorText: ""
    });
    http(
      {
        url: "authenticate?service=ForgotUsername&authIndexType=service&authIndexValue=ForgotUsername",
        data: authenticateData,
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
      // if (
      //   res.status === 200 && res.data && res.data.type === 'CTEmailValidation'
      // ) {
      //   const token = getNestedObject(res, ["data", "token"]);
      //   if (token) {
      //     this.setState({
      //       token
      //     });
      //   }
      //   this.setState({
      //     screen:3,
      //     userEmail:res.data.requirements.userEmail
      //   })
      // }
      // else if (res.status === 200 && res.data && res.data.type === 'codeValidation') {
      //   const token = getNestedObject(res, ["data", "token"]);
      //   if (token) {
      //     this.setState({
      //       token
      //     });
      //   }
      //   this.setState({
      //     screen:3,
      //     verificationOption:res.data.requirements.properties.verificationCode.description
      //   })
      // }
      // else if (
      //   res.status === 400 &&
      //   res.data.message === "Snapshot token is invalid"
      // ) {
      //   this.setState({
      //     showErrorMsg: true
      //   });
      // }
      // else if(res.status === 500 && res.data.code === 500 && res.data.message === 'TWILIO_ERROR'){
      //   this.showError("common.errors.twilioError");
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     selectedOption:''
      //   })
      // }
      // else if(res.status === 500 && res.data.code === 500 && res.data.message === 'SMTP_ERROR'){
      //   this.showError("common.errors.smtpError");
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     selectedOption:''
      //   })
      // }
      // else if(res.status === 200 && res.data && typeof res.data === 'string'){
      //   pageNotFound(res);
      // }
      // else {
      //   this.setState({
      //     showErrorMsg: true
      //   });
      // }
    });
  };

  googleCaptchaReset = () => {
    this.setState({
      captchaReset: true,
      googleCaptchaResponse: ""
    });
    setTimeout(() => {
      this.setState({
        captchaReset: false
      });
    }, 100);
  };

  showError = (errorText) => {
    this.setState({
      errorText
    });
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  };
  displayRandomImage = () => {
    this.setState({
      imageIndex: randomCount()
    });
  };
  onOptionsChange = (value) => {
    if(value.includes("@")){
      value = 'userEmail'
    } else {
      value = 'userPhone'
    }
    this.setState({
      selectedOption:value
    })

  };

  getAuthID = () => {
    http(
      {
        url: "authenticate?service=ForgotUsername&authIndexType=service&authIndexValue=ForgotUsername",
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      if (res && res.status === 200 && res.data.callbacks[0].type === 'StringAttributeInputCallback') {
        this.setState({
          authenticateData: res.data
        });
      } else if (getNestedObject(res, ["data", "detail", "failureUrl"])) {
        const {
          data: {
            detail: { failureUrl }
          }
        } = res;
        if (failureUrl.includes("https://")) {
          window.location.href = sanitizeUrl(`${res.data.detail.failureUrl}`);
          return;
        }
        let errorMsg = "";
        switch (failureUrl) {
          case "INVALID_CREDENTIALS":
            errorMsg = "common.errors.wrongCredentials";
            break;
          case "ACCOUNT_LOCKED":
            errorMsg = "common.errors.accountLocked";
            break;
          case "ACCOUNT_ALREADY_LOCKED":
            errorMsg = "common.errors.accountAlreadyLocked";
            break;
          case "INTERNAL_ERROR":
            errorMsg = "common.errors.internalError";
            break;
          case "MAX_RETRY_EXCEEDED":
            errorMsg = "common.errors.maxVerifyAttempt";
            break;
          case "MAX_RESEND_EXCEEDED":
            errorMsg = "common.errors.maxResendAttempt";
            break;
          case "USER_NOT_FOUND":
            errorMsg = "pages.forgotUserName.userNotFound";
            break;
          case "INVALID_NUMBER":
            errorMsg = "pages.forgotUserName.invalidNumber";
            break;
          case "ALREADY_LOGGED_IN":
            errorMsg = "pages.forgotUserName.alreadyLoggedIn";
            break;
          default:
            errorMsg = "common.errors.internalError";
            break;
        }
        this.showError(errorMsg);
        this.setState({
          screen:1,
          showGoogleCaptcha:false,
          showSuccessMsg:false,
          showErrorMsg:false,
          mail:'',
          verificationCode:'',
          selectedOption:''
        });
      }
    });
  }

  onNext = (e) => {
    e.preventDefault();
    const { selectedOption, authenticateData } = this.state;
    if(selectedOption === 'userPhone'){
      authenticateData.callbacks[1].input[0].value = 1;
    } else {
      authenticateData.callbacks[1].input[0].value = 0;
    }
    this.setState({
      errorText: ""
    });
    http(
      {
        url: "authenticate?service=ForgotUsername&authIndexType=service&authIndexValue=ForgotUsername",
        data: authenticateData,
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
      // if (
      //   res.status === 400 &&
      //   res.data.message === "Snapshot token is invalid"
      // ) {
      //   this.setState({
      //     showErrorMsg: true
      //   });
      // }
      // else if(res.status === 500 && res.data.code === 500 && res.data.message === 'TWILIO_ERROR'){
      //   this.showError("common.errors.twilioError");
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     selectedOption:''
      //   })
      // }
      // else if(res.status === 500 && res.data.code === 500 && res.data.message === 'SMTP_ERROR'){
      //   this.showError("common.errors.smtpError");
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     selectedOption:''
      //   })
      // }
      // else if(res.status === 200 && res.data && typeof res.data === 'string'){
      //   pageNotFound(res);
      // }
      // else {
      //   this.setState({
      //     showErrorMsg: true
      //   });
      // }
    });
  };

  changeMethod = (e) => {
    e.preventDefault();
    const { authenticateData } = this.state;
    authenticateData.callbacks[3].input[0].value = 2;
    this.verificationInputRef.current.__clearvalues__();
    this.setState({
      errorText: "",
      verificationCodeError: ""
    });
    http(
      {
        url: "authenticate?service=ForgotUsername&authIndexType=service&authIndexValue=ForgotUsername",
        data: authenticateData,
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
      // if (
      //   res.status === 400 &&
      //   res.data.message === "Snapshot token is invalid"
      // ) {
      //   this.setState({
      //     showErrorMsg: true
      //   });
      // }
      // else if(res.status === 400 && res.data.code === 400 && res.data.message === 'MAX_RESEND_EXCEEDED'){
      //   this.showError("common.errors.maxResendAttempt");
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     verificationCode:'',
      //     selectedOption:''
      //   })
      // }
      // else if(res.status === 500 && res.data.code === 500 && res.data.message === 'TWILIO_ERROR'){
      //   this.showError("common.errors.twilioError");
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     selectedOption:''
      //   })
      // }
      // else if(res.status === 500 && res.data.code === 500 && res.data.message === 'SMTP_ERROR'){
      //   this.showError("common.errors.smtpError");
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     selectedOption:''
      //   })
      // }
      // else if(res.status === 200 && res.data && typeof res.data === 'string'){
      //   pageNotFound(res);
      // }
      // else {
      //   this.setState({
      //     showErrorMsg: true
      //   });
      // }
    });
  };

  resendVerify= (e) => {
    e.preventDefault();
    this.verificationInputRef.current.__clearvalues__();
    this.setState({
      verificationCode:"",
      verificationCodeError:""
    });
    const { authenticateData } = this.state;
    authenticateData.callbacks[3].input[0].value = 1;
    this.setState({
      errorText: ""
    });
    http(
      {
        url: "authenticate?service=ForgotUsername&authIndexType=service&authIndexValue=ForgotUsername",
        data: authenticateData,
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
      // if (
      //   res.status === 400 &&
      //   res.data.message === "Snapshot token is invalid"
      // ) {
      //   this.setState({
      //     showErrorMsg: true
      //   });
      // } 
      // else if(res.status === 200 && res.data && typeof res.data === 'string'){
      //   pageNotFound(res);
      // }
      // else if(res.status === 400 && res.data.code === 400 && res.data.message === 'MAX_RESEND_EXCEEDED'){
      //   this.showError("common.errors.maxResendAttempt");
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     verificationCode:'',
      //     selectedOption:''
      //   })
      // }
      // else if (getNestedObject(res, ["data", "detail", "failureUrl"])) {
      //   const {
      //     data: {
      //       detail: { failureUrl }
      //     }
      //   } = res;
      //   if (failureUrl.includes("https://")) {
      //     window.location.href = sanitizeUrl(`${res.data.detail.failureUrl}`);
      //     return;
      //   }
      //   let errorMsg = "";
      //   switch (failureUrl) {
      //     case "INVALID_CREDENTIALS":
      //       errorMsg = "common.errors.wrongCredentials";
      //       break;
      //     case "ACCOUNT_LOCKED":
      //       errorMsg = "common.errors.accountLocked";
      //       break;
      //     case "ACCOUNT_ALREADY_LOCKED":
      //       errorMsg = "common.errors.accountAlreadyLocked";
      //       break;
      //     case "INTERNAL_ERROR":
      //       errorMsg = "common.errors.internalError";
      //       break;
      //     case "MAX_RETRY_EXCEEDED":
      //       errorMsg = "common.errors.maxVerifyAttempt";
      //       break;
      //     case "MAX_RESEND_EXCEEDED":
      //       errorMsg = "common.errors.maxResendAttempt";
      //       break;
      //     default:
      //       errorMsg = "common.errors.internalError";
      //       break;
      //   }
      //   this.showError(errorMsg);
      //   this.setState({
      //     screen:1,
      //     showGoogleCaptcha:false,
      //     showSuccessMsg:false,
      //     showErrorMsg:false,
      //     mail:'',
      //     verificationCode:'',
      //     selectedOption:''
      //   });
      //   this.getAuthID();
      // }
      // else {
      //   this.setState({
      //     showErrorMsg: true
      //   });
      // }
    });
  }

  onVerify = (e) => {
    e.preventDefault();
    const { verificationCode, authenticateData } = this.state;
    if (verificationCode === "") {
      this.setState({
        verificationCodeError: "pages.login.verificationCodeRequired"
      });
    } else {
      this.verificationInputRef.current.__clearvalues__();
      this.setState({
        verificationCodeError: ""
      });
      authenticateData.callbacks[2].input[0].value = verificationCode;
      http(
        {
          url: "authenticate?service=ForgotUsername&authIndexType=service&authIndexValue=ForgotUsername",
          data: authenticateData,
          method: "POST"
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
        // if(res.status === 200 && res.data && res.data.type === 'codeValidation'){
        //     const token = getNestedObject(res, ["data", "token"]);
        //     if (token) {
        //       this.setState({
        //         token
        //       });
        //     }
        //     this.setState({
        //       verificationCodeError: "pages.forgotUserName.invalidVerificationCode"
        //     });
        // }
        // else if(res.status === 200 && res.data && typeof res.data === 'string'){
        //   pageNotFound(res);
        // }
        // else if(res.status === 400 && res.data.code === 400 && res.data.message === 'MAX_RETRY_EXCEEDED'){
        //   this.showError("pages.forgotUserName.maxVerifyAttempt");
        //   this.setState({
        //     screen:1,
        //     showGoogleCaptcha:false,
        //     showSuccessMsg:false,
        //     showErrorMsg:false,
        //     mail:'',
        //     verificationCode:'',
        //     selectedOption:''
        //   })
        // }
        // else {
        //   this.setState({
        //     showErrorMsg : true
        //   });
        // }
      });
    }
  };
  handleVerifyChange = (vals) => {
    this.setState({
      verificationCode:vals
    })
  };
  seeMoreHandler = () =>{
    this.setState({
      seeMore: !this.state.seeMore
    })
  }

  render() {
    const { t } = this.props;
    const {
      emailError,
      mail,
      errorText,
      showGoogleCaptcha,
      googleCaptchaToken,
      captchaReset,
      showSuccessMsg,
      showErrorMsg,
      carouselImages,
      imageIndex,screen,
      userEmail,userPhone,
      selectedOption,
      verificationCodeError,
      verificationOption,changeMethod,verificationPlaceholder,switchMethod,
      seeMore
    } = this.state;
    return (
      <>
      <div className={`has-background background-new-image ${errorText && "has-error"}`} style={{ backgroundImage: `url(${carouselImages[imageIndex || 1].image})` }}>
       
        <div className="wrapper forgot-username">
        {errorText && <WithError errors={errorText} />}
          <Container
            className={`container wrapper__container ${
              errorText && "haserror"
            }`}
          >
            <Row>
              <Col lg={{ span: 4 }}>
                <div className="wrapper__container-card">
                  <div className="wrapper__container-card-body">
                    {!showSuccessMsg && !showErrorMsg && (
                      <h1 className="wrapper__container-card-body-title has-desc">
                        {t("pages.forgotUserName.recoverYourUserName")}
                      </h1>
                    )}
                    {screen === 1 && !showGoogleCaptcha && !showSuccessMsg && !showErrorMsg && (
                      <>
                        <p className="wrapper__container-card-body-desc mb-3">
                          <span>{t("pages.forgotUserName.step")} 1: </span>
                          {t("pages.forgotUserName.recoverDesc")}
                        </p>
                        <Form>
                          <Form.Group controlId="loginEmail">
                            <Form.Label>
                              {t("pages.forgotUserName.email")}
                            </Form.Label>
                            <Form.Control
                              type="email"
                              autoFocus
                              onChange={(e) => {
                                this.setState({
                                  mail: e.target.value.trim().toLowerCase()
                                });
                                this.isEmailValid(
                                  e.target.value.trim().toLowerCase()
                                );
                              }}
                              value={mail}
                              className={emailError ? "error-input" : undefined}
                              aria-required
                              aria-invalid={!!emailError}
                              aria-describedby="email-error"
                            />
                            <p className="error-text forgot-error-username" id="email-error">
                              {emailError && t("common.errors.emailError")}
                            </p>
                          </Form.Group>

                          <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => this.onRecoverUserName(e)}
                          >
                            {t("pages.forgotUserName.recoverUserName")}
                          </Button>
                        </Form>
                      </>
                    )}
                    {screen === 1 && showGoogleCaptcha && !showSuccessMsg && !showErrorMsg && (
                      <>
                        <p className="wrapper__container-card-body-desc mb-3">
                          <span>{t("pages.forgotUserName.step")} 2: </span>
                          {t("pages.forgotUserName.fillOutCaptcha")}
                        </p>
                        <div className="google-captcha">
                          <div className="google-captcha__box">
                            {googleCaptchaToken && (
                              <GoogleCaptcha
                                sitekey={googleCaptchaToken}
                                onCaptchaChange={this.onCaptchaChange}
                                captchaReset={captchaReset}
                              />
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {screen === 2 && !showSuccessMsg && !showErrorMsg && (
                      <>
                        <p className="wrapper__container-card-body-desc">
                          <span>{t("pages.forgotUserName.step")} 3: </span>
                          {t("pages.forgotUserName.verificationMethod")}
                        </p>
                        <div>
                        <Radio
                              key={userPhone}
                              name={userPhone}
                              label={`${t("pages.forgotUserName.smsCode")}${" "}${userPhone}`}
                              value={userPhone}
                              isChecked={selectedOption === 'userPhone' ? true : false}
                              handleChange={this.onOptionsChange} 
                            />
                            {selectedOption === 'userPhone' && (
                            <div className="popup__wrapper-body-pleasenote">
                              <span className="popup__wrapper-body-pleasenote-fp">
                              {t("pages.forgotUserName.pleaseNote")}
                              </span>
                              <span className="popup__wrapper-body-pleasenote-sp">
                              {t("pages.forgotUserName.standardRates")}
                              </span>
                            </div>
                            )}
                            
                            <Radio
                              key={userEmail}
                              name={userEmail}
                              label={`${t("pages.forgotUserName.emailCode")}${" "}${userEmail}`}
                              value={userEmail}
                              isChecked={selectedOption === 'userEmail' ? true : false}
                              handleChange={this.onOptionsChange} 
                            />
                            <Button
                      className="wrapper__container-card-body-submit"
                      size="lg"
                      variant="primary"
                      block
                      type="submit"
                      onClick={(e) => this.onNext(e)}
                    >
                      {t("pages.forgotUserName.verify")}
                    </Button>
                         
                        </div>
                      </>
                    )}

                    {screen === 3 && !showSuccessMsg && !showErrorMsg && (
                      <>
                        <div className={"popup__wrapper-body-resend " + (verificationOption.includes("@") ? 'popup__wrapper-body-mobile-icon' : 'popup__wrapper-body-email-icon')}>
                        <p className="wrapper__container-card-body-desc">
                          {t("pages.forgotUserName.enterTheVerificationCode")} {verificationOption}
                        </p>
                        <p
                          className="popup__wrapper-body-resend-btn mt-2"
                          onClick={(e) => this.resendVerify(e)}
                          role="button"
                          tabIndex={0}
                        >
                          {t("pages.editNumberPopup.resendVerificationCode")}
                        </p>
                        </div>
                        <Form>
                        <Form.Group controlId="verificationCode">
                        <Form.Label>
                          {t("pages.editNumberPopup.verificationCode")}
                        </Form.Label>
                        <ReactCodeInput fields={8} ref={this.verificationInputRef}
                          placeholder={verificationPlaceholder}
                          className={`verification-input
                            ${verificationCodeError ? "error-verification" : undefined}`
                          }
                          onChange={this.handleVerifyChange}
                          removeDefaultStyles={true}
                          autoFocus={false}
                          />
                      {verificationCodeError && (
                        <p className="error-text" id="verification-error">
                        {verificationCodeError && t(verificationCodeError)}
                      </p>
                      )}
                      {switchMethod && (
                        <p
                        className="summary-link"
                        role="button"
                        tabIndex={0}
                        onClick={(e) => this.changeMethod(e)}
                        onKeyPress={(e) => this.changeMethod(e)}
                      >
                         {changeMethod === 'EMAIL' ? t("pages.login.emailName") : t("pages.login.phone")}
                      </p>
                      )}
                      </Form.Group>
                      
                      <div className="popup__wrapper-body-pleasenote">
                        <span className="popup__wrapper-body-pleasenote-fp">
                        {t("pages.login.pleaseNote")}
                        </span>
                        <span className="popup__wrapper-body-pleasenote-sp">
                        {t("pages.login.doNotClose")}
                        </span>
                      </div>
                      <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => this.onVerify(e)}
                          >
                            {t("pages.login.verify")}
                      </Button> 
                      </Form>
                      </>
                    )}      
                    {showSuccessMsg && (
                      <div
                        className="notification-card"
                        role="alert"
                        aria-live="polite"
                      >
                        <p className="notification-card__text">
                          {t("pages.forgotUserName.successText")}
                        </p>
                      </div>
                    )}
                    {showErrorMsg && (
                      <ErrorCard
                        title="pages.forgotUserName.userNameErrorTitle"
                        description="pages.forgotUserName.snapshotErrorPage"
                        anchorText="pages.forgotUserName.userNameErrorlinkText"
                        anchorLink="forgotusername"
                      />
                    )}
                  </div>
                  <div className="text-center wrapper__container-card-register">
                    {t("pages.registration.alreadyHaveAccount")}{" "}
                    <Link to={getLoginUrl()} aria-label={t("pages.registration.signInLabel")}>
                      {t("pages.registration.login")}
                    </Link>
                  </div>
                </div>
              </Col>
              <Col lg={{ span: 8 }} className="forgot-username-right-content">
                  
                    <div className="forgot-username__right-container">
                    
                      <div className="forgot-username__right-container-heading"> {t("pages.login.welcomeText")}</div>
                      <span className={seeMore ? 'forgot-username__right-container-service block show': 'forgot-username__right-container-service block'}>
                        <span className="forgot-username__right-container-subheading">{t("pages.login.serviceTextOne")}</span>
                        {/* <span className="forgot-username__right-container-subheading hide">{t("pages.login.serviceTextTwo")}</span> */}
                        <span className="forgot-username__right-container-subheading forgot-username__right-container-subheading-bold inline-block hide">
                          {t("pages.login.needAnAccount") + " "} 
                          <Link to={`${getRoutePath}/registration`} aria-label={t("pages.login.createOne")}>
                            {t("pages.login.createOne")}
                          </Link>
                        </span>
                      </span>
                      
                      <div className="bottom-section">
                        <div className="separator"></div>
                        <div className="forgot-username__right-container-subhead">{t("pages.login.security")}</div>
                        <span className="forgot-username__right-container-subcontent block">
                        {t("pages.login.securityDesc")}</span>
                        <a className="forgot-username__right-container-link" href="https://portal.ct.gov/ctidentity/mfa-faq?language=en_US" target="_blank" aria-label={t("pages.login.readMore")}>{t("pages.login.readMore")}</a>
                      </div>
                      <p className={seeMore ? 'open see-more mt-3': 'see-more mt-3'} aria-label="" tabIndex={0} role="button" onClick={this.seeMoreHandler} onKeyPress={this.seeMoreHandler}><span className="more">{t("pages.login.seeMore")}</span><span className="less">{t("pages.login.seeLess")}</span><img src={downChevron} alt="down-chevron"></img></p>
                    </div>
                  </Col>
            </Row>
          </Container>
        </div>
        </div>
      </>
    );
  }
}

ForgotUserName.propTypes = {
  t: PropTypes.func.isRequired
};
export default withTranslation()(ForgotUserName);